(function () {
    if (window.__fbCarousel) {
        window.__fbCarousel.init();
        return;
    }

    var mobileQuery = window.matchMedia('(max-width: 991px)');

    function setup(root) {
        if (root.__fbReady) {
            root.__fbRebuild();
            return;
        }
        root.__fbReady = true;

        var track = root.querySelector('.fb-track');
        var dotsWrap = root.querySelector('.fb-dots');
        var positions = [];
        var ticking = false;

        function getPositions() {
            var max = track.scrollWidth - track.clientWidth;
            if (max <= 2) return [];
            var isMobile = mobileQuery.matches;
            var result = [];
            Array.prototype.forEach.call(track.children, function (slide) {
                if (slide.offsetParent === null) return;
                if (isMobile && !slide.classList.contains('fb-slide--snap')) return;
                var pos = Math.min(slide.offsetLeft, max);
                if (!result.length || pos - result[result.length - 1] > 2) result.push(pos);
            });
            return result.length > 1 ? result : [];
        }

        function updateActive() {
            ticking = false;
            var current = track.scrollLeft;
            var best = 0;
            positions.forEach(function (pos, i) {
                if (Math.abs(pos - current) < Math.abs(positions[best] - current)) best = i;
            });
            Array.prototype.forEach.call(dotsWrap.children, function (item, i) {
                var active = i === best;
                item.classList.toggle('slick-active', active);
                item.firstChild.setAttribute('aria-selected', active ? 'true' : 'false');
            });
        }

        function rebuild() {
            positions = getPositions();
            dotsWrap.innerHTML = '';
            positions.forEach(function (pos, i) {
                var item = document.createElement('li');
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.setAttribute('role', 'tab');
                dot.setAttribute('aria-label', 'Ir para o banner ' + (i + 1));
                dot.addEventListener('click', function () {
                    track.scrollTo({ left: pos, behavior: 'smooth' });
                });
                item.appendChild(dot);
                dotsWrap.appendChild(item);
            });
            updateActive();
        }

        track.addEventListener('scroll', function () {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(updateActive);
            }
        }, { passive: true });
        window.addEventListener('resize', rebuild);
        root.__fbRebuild = rebuild;
        rebuild();
    }

    function init() {
        document.querySelectorAll('[data-fb-carousel]').forEach(setup);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    window.__fbCarousel = { init: init };
    document.addEventListener('shopify:section:load', init);
    window.addEventListener('load', init);
})();
